import { render, staticRenderFns } from "./contrast-indicator.vue?vue&type=template&id=5286e646&scoped=true&"
import script from "./contrast-indicator.vue?vue&type=script&lang=js&"
export * from "./contrast-indicator.vue?vue&type=script&lang=js&"
import style0 from "./contrast-indicator.vue?vue&type=style&index=0&id=5286e646&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5286e646",
  null
  
)

export default component.exports